import { CommonCountryResponse, CommonMunicipalityResponse, CommonProvinceResponse } from '@/api/services/common.dto'
import axios from 'axios'

class CommonAddressService {
    async getCountries(): Promise<CommonCountryResponse[]> {
        const response = await axios.get<CommonCountryResponse[]>(`/countries/index`)
        return response.data
    }

    async getProvinces(countryId: number): Promise<CommonProvinceResponse[]> {
        const response = await axios.get<CommonProvinceResponse[]>(`/countries/${countryId}/provinces/index`)
        return response.data
    }

    async getMunicipalities(provinceId: number): Promise<CommonMunicipalityResponse[]> {
        const response = await axios.get<CommonMunicipalityResponse[]>(`/provinces/${provinceId}/municipalities/index`)
        return response.data
    }
}

export const commonAddressService = new CommonAddressService()
